import {
	IGetVideoInfo,
	ICreateVideo,
	IEditVideo,
	IGetPaginatedVideos,
	IVideos,
	IGetRestaurantsByIDsCustomersForVideos,
	IGetVideosByIDsRestaurantsForVideos,
	IAssignVideos,
	IGetVideoCategoryInfo,
	IGetVideoCategoriesShort,
	ICreateVideoCategory,
	IUpdateVideoCategory,
	IGetPaginatedVideoCategories,
	IVideoCategories,
	IGetVideoStudioInfo,
	IGetVideoStudiosShort,
	ICreateVideoStudio,
	IUpdateVideoStudio,
	IGetPaginatedVideoStudios,
	IVideoStudios,
	IGetCustomersForAssignVideos,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetVideoInfo = (videoID: string): Promise<IGetVideoInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Videos/${videoID}` });
};

const serviceCreateVideo = (data: ICreateVideo): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Videos`, data });
};

const serviceUpdateVideo = (data: IEditVideo): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Videos/${data.id}`, data });
};

const serviceGetPaginatedVideos = (args: IGetPaginatedVideos): Promise<AxiosResponse<IVideos>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Videos/filtered`, data: args });
};

const serviceDeleteVideo = (videoID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/Videos/${videoID}` });
};

const serviceGetCustomersForAssignVideos = (): Promise<IGetCustomersForAssignVideos> => {
	return request({ typeOfRequest: 'getWithToken', url: '/api/VideosAssignment/customers' });
};

const serviceGetRestaurantsByIDsCustomersForVideos = (
	customerIDs: string[],
): Promise<IGetRestaurantsByIDsCustomersForVideos> => {
	const dataForRequest = {
		customerIds: customerIDs,
	};
	return request({ typeOfRequest: 'postWithToken', url: `/api/VideosAssignment/customers`, data: dataForRequest });
};

const serviceGetVideosByIDsRestaurantsForVideos = (
	restaurantIDs: string[],
): Promise<IGetVideosByIDsRestaurantsForVideos> => {
	const dataForRequest = {
		restaurantIds: restaurantIDs,
	};
	return request({ typeOfRequest: 'postWithToken', url: `/api/VideosAssignment/restaurants`, data: dataForRequest });
};

const serviceAssignVideos = (data: IAssignVideos[]): Promise<AxiosResponse<void>> => {
	const dataForAssign = {
		assignments: data,
	};
	return request({ typeOfRequest: 'putWithToken', url: '/api/VideosAssignment/assign', data: dataForAssign });
};

// VideoCategories
const serviceGetVideoCategoryInfo = (categoryID: string): Promise<IGetVideoCategoryInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/VideoCategories/${categoryID}` });
};

const serviceGetVideoCategoriesShortInfo = (): Promise<IGetVideoCategoriesShort> => {
	return request({ typeOfRequest: 'getWithToken', url: '/api/VideoCategories/short' });
};

const serviceCreateVideoCategory = (data: ICreateVideoCategory): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/VideoCategories`, data });
};

const serviceUpdateVideoCategory = (data: IUpdateVideoCategory): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/VideoCategories/${data.id}`, data });
};

const serviceGetPaginatedVideoCategories = (
	args: IGetPaginatedVideoCategories,
): Promise<AxiosResponse<IVideoCategories>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/VideoCategories/filtered`, data: args });
};

const serviceDeleteVideoCategory = (categoryID: string): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/VideoCategories/${categoryID}`,
	});
};
// VideoCategories

// VideoStudios
const serviceGetVideoStudioInfo = (studioID: string): Promise<IGetVideoStudioInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/VideoStudios/${studioID}` });
};

const serviceGetVideoStudiosShortInfo = (): Promise<IGetVideoStudiosShort> => {
	return request({ typeOfRequest: 'getWithToken', url: '/api/VideoStudios/short' });
};

const serviceCreateVideoStudio = (data: ICreateVideoStudio): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/VideoStudios`, data });
};

const serviceUpdateVideoStudio = (data: IUpdateVideoStudio): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/VideoStudios/${data.id}`, data });
};

const serviceGetPaginatedVideoStudios = (args: IGetPaginatedVideoStudios): Promise<AxiosResponse<IVideoStudios>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/VideoStudios/filtered`, data: args });
};

const serviceDeleteVideoStudio = (studioID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/VideoStudios/${studioID}` });
};
// VideoStudios

export {
	serviceGetVideoInfo,
	serviceCreateVideo,
	serviceUpdateVideo,
	serviceGetPaginatedVideos,
	serviceDeleteVideo,
	serviceGetCustomersForAssignVideos,
	serviceGetRestaurantsByIDsCustomersForVideos,
	serviceGetVideosByIDsRestaurantsForVideos,
	serviceAssignVideos,
	serviceGetVideoCategoryInfo,
	serviceGetVideoCategoriesShortInfo,
	serviceCreateVideoCategory,
	serviceUpdateVideoCategory,
	serviceGetPaginatedVideoCategories,
	serviceDeleteVideoCategory,
	serviceGetVideoStudioInfo,
	serviceGetVideoStudiosShortInfo,
	serviceCreateVideoStudio,
	serviceUpdateVideoStudio,
	serviceGetPaginatedVideoStudios,
	serviceDeleteVideoStudio,
};
